// TODO This does not include postcodeRegex constraint... should it be added?
const POSTCODE_CONSTRAINT_NAMES = [
  'postcode',
  'primary_address_postalcode',
  'postcodeRegex',
];

export default POSTCODE_CONSTRAINT_NAMES;
